import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestRegisterGuard } from '../../guards/guest-register.guard';

export const admin: Routes = [
  {
    path: 'register',
    loadComponent: () => import('./guest-register.component').then((m) => m.GuestRegisterComponent),
    canActivate: [GuestRegisterGuard],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class guestRegisterRoutingModule {
  static routes = admin;
}
